"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var UserBrowser_1 = __importDefault(require("./UserBrowser"));
function initialize(options) {
    UserBrowser_1.default.Partner = options.partner;
}
exports.initialize = initialize;
var UserBrowser_2 = require("./UserBrowser");
exports.UserBrowser = UserBrowser_2.default;
//# sourceMappingURL=index.js.map